import { LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';

@customElement('calendar-element')
export class CalendarElement extends LitElement {

	// Props
	@state()
	_slotNodes: Node[] = [];

	// Lifecycle Hooks

	firstUpdated() {

		// add classes
		this.classList.add('Calendar');

		// slots
		const slot: HTMLElement | null = this.querySelector('[slot="body"]');
		if (slot) {
			this._slotNodes = Array.from(slot.childNodes);
			this._slotNodes.forEach((node) => {
				this.appendChild(node);
			});
		}

		// observer
		document.addEventListener('navstuck', () => {
			this.classList.add('is-belowNav');
		});
		document.addEventListener('navunstuck', () => {
			this.classList.remove('is-belowNav');
		});
	}

	createRenderRoot() { 
		return this;
	}

}